import { Grid, InputAdornment, TextField } from "@mui/material";


type CustomInputMetodoPagoProps = {
  metodo: string;
  value: string | number;
  onChange: (metodo: string, value: string) => void;
  modo: 'porcentaje' | 'cantidad'
}
export default function CustomInputMetodoPago({
  metodo,
  value,
  onChange,
  modo
}: CustomInputMetodoPagoProps) {
  const simbolo = modo === "porcentaje" ? '%' : '$';
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value;

    // Permitir el punto suelto para que el usuario pueda escribir números decimales
    if (val === '.') {
      onChange(metodo, '0.');
      return;
    }

    const regex = /^\d*(\.\d{0,2})?$/;
    if (regex.test(val)) {
      // Evitar múltiples ceros al inicio, pero conservar "0." o "0.1"
      if (val.startsWith('0') && !val.startsWith('0.') && val.length > 1) {
        val = val.replace(/^0+/, '');
      }
      onChange(metodo, val);
    }
  }
  return (
    <>
      <Grid item>
        <TextField
          variant="outlined"
          label={metodo}
          name={`porcentaje_${metodo}`}
          size='small'
          type="number"
          InputProps={{
            endAdornment: <InputAdornment position="end">{simbolo}</InputAdornment>
          }}
          value={value.toString() || ''}
          //onChange={(e)=>{console.log(metodo,e.target.value)}}
          onChange={handleInputChange}
        />

      </Grid>

    </>
  )
}